<template>
  <div id="activityLocationSearch">
    <label>{{t('Location')}}</label>
    <v-select :label="`name_${language}`" placeholder="Portugal" :value.sync="location" class="vSelect" name="location" :onChange="setLocation" id="locationSearch" :options="inputOptions" label="label"></v-select>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import vSelect from 'vue-select';

export default {
  name: 'SearchLocation',
  components: {
    vSelect,
  },
  computed: {
    ...mapState({
      language: state => state.language,
      locations: state => state.locations,
      location: state => state.search.location,
    }),
    inputOptions() {
      const options = [
        {
          value: 1,
          label: 'Portugal',
        },
      ];
      Object.keys(this.locations.nuts2ById).forEach((key) => {
        options.push({
          value: key,
          label: this.locations.nuts2ById[key],
        });
      });
      this.location = options[0];
      return options;
    },
  },
  methods: {
    setLocation(val) {
      if (val !== null) {
        this.$store.dispatch('search/setLocation', val);
      } else {
        this.$store.dispatch('search/setLocation', {});
      }
    },
  },
};

</script>

<style lang="scss" scoped>
/*.activityLocationSearch {
padding-left: 12px;
}*/

</style>

<style lang="scss">
@import "../../assets/scss/variables-b4";
#activityLocationSearch {
  text-align: left;
  position:relative;
  z-index: 1000;
  label {
    color: white;
    position: absolute;
    top: -12px;
  }

  .dropdown-toggle {
    padding-top: 14px;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 1);
    min-height: 46px;
    input::placeholder {
      color: white;
    }
  }
  .dropdown-menu {
    max-height: 400px;
    overflow-y: auto;
    background: $brand-primary;
    a {
      color: white;
    }
    a:hover {
      background-color: darken($brand-primary, 5%);
    }
    .highlight a, highlight a:hover {
      background: white !important;
      color: $brand-primary !important;
    }
    .active.highlight:hover a {
      color: $brand-primary !important;
    }
  }

  .open-indicator::before {
    border-color: white;
  }

  .form-control {
    position: absolute !important;
    left: 0;
  }

  .selected-tag {
    padding: 0;
    background: transparent;
    border: 0;
    color: white;
  }
}

</style>



// WEBPACK FOOTER //
// SearchLocation.vue?326b42d6